import { render, staticRenderFns } from "./LogoServiroute.vue?vue&type=template&id=553825d5"
import script from "./LogoServiroute.vue?vue&type=script&lang=js"
export * from "./LogoServiroute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports